import { render, staticRenderFns } from "./Section6.vue?vue&type=template&id=4b287be0&scoped=true&"
import script from "./Section6.vue?vue&type=script&lang=js&"
export * from "./Section6.vue?vue&type=script&lang=js&"
import style0 from "./Section6.vue?vue&type=style&index=0&id=4b287be0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b287be0",
  null
  
)

export default component.exports